<div class="mat-simple-snackbar">
  <div [innerHTML]="data.html" class="validation-error"></div>
  <div class="mat-simple-snackbar-action ng-star-inserted">
    <button mat-raised-button (click)="snackBar.dismiss()" 
            class="mat-focus-indicator mat-button mat-button-base">
      Close
    </button>
  </div>
</div>